/**
 * @generated SignedSource<<ef3f54e4acc51b0dfee3f98ac65d962d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespProductTileCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_viewer">;
  readonly " $fragmentType": "PdpRespProductTileCarousel_viewer";
};
export type PdpRespProductTileCarousel_viewer$key = {
  readonly " $data"?: PdpRespProductTileCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespProductTileCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4f73dc58d9146e2b0760a1a4239bb377";

export default node;
